import { Document, Page, pdfjs } from 'react-pdf';
import { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { SelectInput } from '../form';
import { MobileFlexCss } from '..';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const DocumentDiv = styled(Document)`
  ${MobileFlexCss};
`;

const PDFDocumentWrapper = styled.div`${({ theme }) => `
  display: inline-block;
  padding: 0 ${theme.padding[4]};
  canvas {
    width: 190px !important;
    height: 200px !important;
    border: 1px solid ${theme.borderFaint};
    border-radius: ${theme.borderRadius[1]};
    margin: 0 auto;
  }

  span, section {
    display: none;
  }

  select {
    width: 100%;
    font-size: ${theme.fontSize[2]};
  }

  &:hover {
    div:last-child {
      display: block;
    }
  }

  p {
    font-size: ${theme.fontSize[2]};
    text-align: left;
    margin-top: ${theme.padding[1]};
  }
`}`;

const StyledDeleteIcon = styled.div`${({ theme }) => `
  color: ${theme.textSecondary};
  font-size: ${theme.fontSize[2]};
  position: absolute;
  z-index: 2;
  top: 30%;
  right: 45%;
  background: red;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  display: none;
`}`;

const SelectWrapper = styled.div`
  display: flex;
`;

const StyledText = styled.div`${({ theme }) => `
  width: 190px;
  font-size: ${theme.fontSize[2]};
  text-align: left;
  margin: ${theme.padding[1]} 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${theme.banner};
  padding: ${theme.padding[1]} ${theme.padding[2]};
`}`;

interface ValidationType {
  [key: string]: string[];
}

export const findDuplicates = (arr: any) => arr.filter((item: any, index: number) => arr.indexOf(item) !== index);

export function Pdf({
  onDocumentLoadSuccess,
  selectedFile,
  selectedFileIndex,
  pageCount,
  pageTypes,
  setPageTypes,
  fileTypeOptions,
  handleDeleteFile,
  showWrapper = false,
}: {
  onDocumentLoadSuccess: any,
  selectedFile: any,
  selectedFileIndex: any,
  pageCount: any,
  pageTypes: any,
  setPageTypes: any,
  fileTypeOptions: any,
  handleDeleteFile?: (fileIndex: number) => void,
  showWrapper?: boolean,
}) {
  const [validation, setValidation] = useState<ValidationType>({});
  const Wrapper = showWrapper ? PDFDocumentWrapper : Fragment;

  const handleValidation = (data: any) => {
    const field: string = 'pageTypes';
    if (Object.values(pageTypes).some((item: any) => item[0] === data[Object.keys(data)[0]][0])) {
      setValidation((prev) => ({ ...prev, [field]: ['Duplicate Document Type'] }));
    } else {
      setValidation((prev) => ({ ...prev, [field]: [''] }));
    }
  };

  useEffect(() => {
    const field: string = 'pageTypes';
    if (pageTypes?.[selectedFileIndex]?.[0] === '0') {
      setValidation({ ...validation, [field]: ['Label required'] });
    } else if (findDuplicates([pageTypes?.[0]?.[0], pageTypes?.[1]?.[0], pageTypes?.[2]?.[0]]).length === 0) {
      setValidation({ ...validation, [field]: [''] });
    }
  }, [onDocumentLoadSuccess]);

  return (
    <Wrapper>
      <DocumentDiv onLoadSuccess={onDocumentLoadSuccess} file={selectedFile}>
        {pageCount[selectedFileIndex] && [...Array(pageCount[selectedFileIndex])].map((_x, index) => (
          // @ts-ignore
          <Page pageNumber={index + 1} height={250} key={`page-${selectedFileIndex}`}>
            <StyledText>{selectedFile.name}</StyledText>
            <SelectWrapper>
              <SelectInput
                id={`select-page-type-${selectedFileIndex}`}
                value={pageTypes[selectedFileIndex][index]}
                options={fileTypeOptions}
                onChange={(value: any) => {
                  setPageTypes((prev: any) => ({ ...prev, [selectedFileIndex]: { [index]: value } }));
                  handleValidation({ [selectedFileIndex]: { [index]: value } });
                }}
                errors={validation?.pageTypes ?? []}
                touchOverride={!!validation?.pageTypes?.[0]}
              />
            </SelectWrapper>
            <StyledDeleteIcon onClick={() => handleDeleteFile && handleDeleteFile(selectedFileIndex)}>
              <i className="mi-close" />
            </StyledDeleteIcon>
          </Page>
        ))}
      </DocumentDiv>
    </Wrapper>
  );
}
